import withLazyAndSuspense from '../../../utils/lazy';
import JH_URL_CONSTANTS from '../data/URLConstants.js';

const RekycJH = withLazyAndSuspense(() => import('../rekyc'));

const RekycJH2 = withLazyAndSuspense(() => import('../rekyc'));

const RekycJHSuccess = withLazyAndSuspense(() => import('../rekycSuccess'));

const JHSecondaryMobileVerification = withLazyAndSuspense(() => import('../container/secondaryMobileVerification'));

const jhError = withLazyAndSuspense(() => import('../error.web'));

const RekycJHHome = withLazyAndSuspense(() => import('../main.web'));

const RekycJHData = withLazyAndSuspense(() => import('../data.web'));

const RekycJointHolderRouteMap = {
  RekycJH: {
    component: RekycJH,
    path: JH_URL_CONSTANTS.JH_LANDING,
  },
  RekycJH2: {
    component: RekycJH2,
    path: JH_URL_CONSTANTS.JH2_LANDING,
  },
  RekycJHSuccess: {
    component: RekycJHSuccess,
    path: JH_URL_CONSTANTS.JH_SUCCESS,
  },
  JHSecondaryMobileVerification: {
    component: JHSecondaryMobileVerification,
    path: JH_URL_CONSTANTS.JH_SECONDARY_MOBILE_VERIFICATION,
  },
  RekycJHHome: {
    component: RekycJHHome,
    path: JH_URL_CONSTANTS.JH_HOME,
  },
  RekycJHData: {
    component: RekycJHData,
    path: JH_URL_CONSTANTS.JH_DATA,
  },
  jhError: {
    component: jhError,
    path: JH_URL_CONSTANTS.JH_ERROR_REDIRECT,
  },
};

export default RekycJointHolderRouteMap;
